import { APICore } from '../helpers/api/apiCore';
import { findObject } from '../utils/AllFunction';
import { apiReturnCallBack } from './ApiConfig';
import apiContainer from './apiContainer';
const api = new APICore();

const Sales = apiContainer.Sales
const SalesNo = apiContainer.SalesNo
const SalesDetails = apiContainer.SalesDetails
//GET--->
// Corrected getSales function
export async function getSalesApi(request) {
    let findObj = findObject(request);
    try {
        return api.get(`${Sales}`, findObj);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}

export async function getSalesNoApi(request) {
    let findObj = findObject(request);
    try {
        return api.get(`${SalesNo}`, findObj);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//CREATE---->
export async function createSales(request) {
    try {
        return api.create(`${Sales}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//UPDATE---->
export async function updateSales(request, SalesId) {
    try {
        return api.update(`${Sales}/${SalesId}`, request);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}
//DELETE---->
export async function deleteSales(SalesId) {
    try {
        return api.delete(`${Sales}/${SalesId}`);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}

export async function deleteSalesDetails(SalesDetailsId) {
    try {
        return api.delete(`${SalesDetails}/${SalesDetailsId}`);
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}





